import React, { Component } from 'react'
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import Banner from '../../components/terms/banner'
import { Layout, Typography, Icon } from 'antd';
import { Helmet } from "react-helmet";
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getTC } from '../../../../core/actions/tccontents';
const { Title } = Typography;
const { Content } = Layout;
class Terms extends Component {
  constructor(props) {
    super(props)
    this.state = {
      content: ''
    }
  }

  componentWillMount() {
    window.scrollTo({ top: 0 });
  }

  componentDidMount() {
    window.fbq('track', 'ViewContent');
    this.props.getTC()
  }

  componentWillReceiveProps(nextProps) {
    let { tcContent } = nextProps
    if (tcContent.content.length > 0) {
      this.setState({
        content: tcContent.content
      })
    }
  }

  render() {
    const { content } = this.state
    return (
      <div>
        <Helmet>
          <title>Privacy policy</title>
        </Helmet>
        {
          content.length ?
            <div  className="terms-page">
              <TopNav history={this.props.history} />
              <Banner />
              <Content>
                <div className="main">
                  <section className="terms-holder" dangerouslySetInnerHTML={{ __html: content }}>
                  </section>
                </div>
              </Content>
              <Footer />
            </div>
            :
            <div className="x-loader">
              <Icon type="loading" style={{ fontSize: 60 }} spin />
            </div>
        }
      </div>
    )
  }
}


const mapStateToProps = (state) => ({
  tcContent: state.tcContents.tcContent
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getTC
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Terms)
